export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// /Users/chrisessig/Documents/tribune/github/redistricting-CD27/node_modules/d3-svg-annotation/node_modules/d3-selection/src/selection/empty.js
// module id = null
// module chunks = 